import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24.679" height="29.606" viewBox="0 0 24.679 29.606" {...props}><path d="M24.679 14.833L0 29.607V0l24.679 14.833z" /></svg>);